'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Section = require('../vendor/canvas/Section');

var _Section2 = _interopRequireDefault(_Section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  default: '',
  island: 'is--island'
};

var UISection = _react2.default.createClass({
  displayName: 'UISection',

  propTypes: _extends({}, _Section2.default.propTypes, {
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _Section2.default.defaultProps, {
      use: 'default'
    });
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        overhang = _props.overhang,
        overhangDirection = _props.overhangDirection,
        use = _props.use;

    return (0, _reactUtils.classNames)('is--module', USE_CLASSES[use], className, 'namespaced-hack-section', {
      'private-scroll__wrapper--horizontal namespaced-hack-section--horizontal': overhang && overhangDirection === 'horizontal',
      'namespaced-hack-section--vertical': overhang && overhangDirection === 'vertical'
    });
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        overhang = _props2.overhang,
        overhangDirection = _props2.overhangDirection,
        use = _props2.use,
        rest = _objectWithoutProperties(_props2, ['children', 'overhang', 'overhangDirection', 'use']);

    return _react2.default.createElement(
      _Section2.default,
      _extends({}, rest, {
        className: this.getClassName(),
        overhang: overhang,
        overhangDirection: overhangDirection,
        use: use
      }),
      children
    );
  }
});

exports.default = UISection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/section/UISection.js
// module id = 67
// module chunks = 0